import classNames from 'classnames';
import { useCities } from 'providers/cities';
import { FunctionComponent } from 'react';

interface LogoProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

const Logo: FunctionComponent<LogoProps> = ({ className, ...divProps }) => {
  const { selectedCity } = useCities();
  return (
    <div {...divProps} className={classNames('flex items-center', className)}>
      {/* <div className="flex w-10 h-10 bg-theme-border mr-2">
        <div className="m-auto">
          <img className="max-w-8 max-h-8" src={`data:image/png;base64,${selectedCity?.logo_image}`} alt="" />
        </div>
      </div> */}
      <div className='text-[20px] font-extrabold'>TvarkauMiesta.lt</div>
    </div>
  );
};

export default Logo;
